module.exports = __webpack_public_path__ + "img/kubernetes.7b91a4b4.svg";